import {AppActions, useAppContext} from "../../Context/ProjectContextV2";
import 'leaflet-arrowheads';
import 'leaflet-polylinedecorator';
import 'leaflet-simple-map-screenshoter'
import 'leaflet-control-mini-map/dist/minimap.css';
import 'leaflet-measure'
import 'leaflet-measure/dist/leaflet-measure.css'
import 'leaflet-kmz'
import 'leaflet-geometryutil'
import 'leaflet-draw'
// import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet-snap'
import 'leaflet.markercluster'
import 'leaflet-search'
import 'leaflet-search/dist/leaflet-search.min.css'
import 'leaflet/dist/images/marker-icon-2x.png'

import _ from 'lodash'
import {SimpleMapScreenshoter} from 'leaflet-simple-map-screenshoter'
import {useEffect, useRef, useState} from "react";
import {useModal} from "../../Context/ModalContext";
import {v4} from "uuid";
import KML from "./MapPlugins/KML";
import MouseCoord from "./MapPlugins/MouseCoord";
import proj4 from "proj4";
import MeasureTool from "./MapPlugins/MeasureTool";
import FullExtend from "./MapPlugins/FullExtend";
import TileSelect from "./MapPlugins/TileSelect";
import ProfileSelect from "./MapPlugins/ProfileSelect";
import {MapContainer} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'
import {Modal, notification, Space, Spin} from "antd";
import '@meteo-concept/leaflet-inflatable-markers-group';
import './map-view.css'
import LayerSelect from "./MapPlugins/LayerSelect";
import CrossSectionWindow from "../Output/UI/CrossSection/CrossSectionWindow";
import ReactDOMServer from 'react-dom/server';
import {BridgeTable, CulvertTable} from "../Output/Internal/B40";
import ShapeFileHelper from "../../Helpers/ShapeFileHelper";
import ShapeItem, {ShapeTooltip} from "./ShapeItem";
import StructureName from "./MapPlugins/StructureName";
import MapProjectInfo from "./MapPlugins/MapProjectInfo";
import createLeafletPopup from "./CreateLeafletPopup";
import FlowChangeTable from "./FlowChangeTable";
import HecRasHelper from "../../Helpers/HecRasHelper";
import BoundaryTable from "./BoundaryTable";
import LayerSearch from "./MapPlugins/LayerSearch";
import ResultTable from "../Table/ResultTable";
import ResultRow from "../Table/ResultRow";
import ResultHeader from "../Table/ResultHeader";
import ResultHeaderCell from "../Table/ResultHeaderCell";
import ResultBodyCell from "../Table/ResultBodyCell";
import GeoRasterLayer from "georaster-layer-for-leaflet";
import chroma, {scale} from "chroma-js";


const getTiles = () => {
    return [
        {tile: 'Google Street', url: 'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080'},
        {tile: 'Google Hybrid', url: 'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'Google Satellite', url: 'http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'Google Terrain', url: 'http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080'},
        {tile: 'USGS The National Map (TNM)', url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}', options: {maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080'},
        {tile: 'USGS Imagery Only', url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}', options: {maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'USGS Topo', url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}', options: {maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'OpenStreetMap', url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        // {tile: 'ArcGIS USA Topo', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/USA_Topo_Maps/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'ArcGIS World Street Map', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'ArcGIS World Imagery', url: 'https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', textColor: 'white', csColor: '#39FF14', options: {maxZoom: 25}, structure: 'yellow'},
        // {tile: 'ArcGIS NatGeo World Map', url: 'https://services.arcgisonline.com/arcgis/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}\n', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        // {tile: 'ArcGIS Physical World Map', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Physical_Map/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        // {tile: 'ArcGIS World Shaded Relief', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        // {tile: 'ArcGIS World Terrain Base', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Terrain_Base/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'ArcGIS World Topo Map', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'ArcGIS USA', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
    ]
}

const defaultData = {
    tile: null,
    river: null,
    streamArrow: null,
    banks: [],
    banksLayer: null,
    mannings: [],
    manningsTexts: [],
    manningsLayer: null,
    manningsTextLayer: null,
    ineffs: [],
    ineffLayer: null,
    crossSections: [],
    crossSectionTexts: [],
    crossSectionLayer: null,
    crossSectionTextLayer: null,
    blockObst: [],
    blockObstLayer: null,
    structures: [],
    structureLayer: null,
    structureTexts: [],
    structureTextLayer: null,
    multipleOpeningLines: [],
    multipleOpeningLinesLayer: null,
    floodExtends: [],
    floodExtendsLayer: null,
    referenceLayers: [],
}

const getCenter = (coords) => {
    let sum_x = 0;
    let sum_y = 0;

    for (const coord of coords) {
        sum_x += coord[0]
        sum_y += coord[1]
    }

    return [sum_x/coords.length, sum_y/coords.length]
}


export default function MapViewV2({type}) {
    const [map, setMap] = useState(null)
    const isReady = useRef(false)
    const [size, setSize] = useState({height: window.innerHeight - 125, width: window.innerWidth-2})
    const {selectedHistoryId, getSelectedHistory, dispatchProject, getSelectedRS, mapContext, getProjectLayers, getRiverBoundingCoords, getMapData, getCSList} = useAppContext()
    const {openModal, closeModal} = useModal()
    const [tile, setTile] = useState(getTiles()[0])
    const [updateStream, setUpdateStream] = useState(0)
    const [profile, setProfile] = useState(null)
    const prevSelectedRS = useRef(getSelectedRS()?.cross_section)
    const [fullExtendEvent, setFullExtendEvent] = useState(null)
    const mapObjects = useRef({
        tile: null,
        river: null,
        flow_path_left: null,
        flow_path_right: null,
        streamArrow: null,
        banks: [],
        banksLayer: null,
        mannings: [],
        manningsTexts: [],
        manningsLayer: null,
        manningsTextLayer: null,
        ineffs: [],
        ineffLayer: null,
        crossSections: [],
        crossSectionTexts: [],
        crossSectionLayer: null,
        crossSectionTextLayer: null,
        flowChanges: [],
        flowChangeLayer: null,
        downstreamBoundary: null,
        blockObst: [],
        blockObstLayer: null,
        structures: [],
        structureLayer: null,
        structureTexts: [],
        structureTextLayer: null,
        multipleOpeningLines: [],
        multipleOpeningLinesLayer: null,
        floodExtends: [],
        floodExtendsLayer: null,
        referenceLayers: [],
        projectLayers: [],
        drawControl: null,
        plugins: [],
        searchLayer: null,
        textLayer: null,
        loadLayerTimeout: null
    })

    const handleResize = () => {
        setSize({
            width: window.innerWidth-32,
            height: window.innerHeight-125,
        })
    }

    const getProjection = () => {
        return getSelectedHistory()?.selection[type]?.project?.projection?.text
    }

    const fullExtend = async (e) => {
        try {

            const data = await ShapeFileHelper.getBounding(getRiverBoundingCoords(type), mapContext[type]?.bounding)

            map?.fitBounds([
                data[1],
                data[3],
            ])
        }
        catch (exp) {
            console.log(exp)
        }
    }

    const getColor = (csName, type, defColor) => {
        const inFilter = HecRasHelper.inFilter({us: getSelectedHistory()?.page?.filter?.us, ds: getSelectedHistory()?.page?.filter?.ds, cs_name: csName})
        if(type === 'text' && inFilter) {
            return '#00a8ff'
        }
        if(type === 'cross_section' && inFilter) {
            return '#00a8ff'
        }
        if(type === 'structure' && inFilter) {
            return '#00a8ff'
        }

        return defColor
    }

    const loadPlugins = () => {
        if(mapObjects.current.plugins.length > 0) {
            return
        }

        window.guideLayers = []
        MouseCoord(L, getProjection(), proj4, map)
        MapProjectInfo(L, type, map)
        FullExtend(L, type)
        KML(L)

        MeasureTool(L, map)
        const Ruler = L.Control.LinearMeasurement.extend({
            layerSelected: function(e){}
        });
        mapObjects.current.plugins.push(map.addControl(new Ruler({
            unitSystem: 'imperial',
            color: '#04d9ff',
            show_azimut: false
        })))

        map.removeControl(map.zoomControl);
        mapObjects.current.plugins.push(L.control.fullExtend({}).addTo(map));

        map.on(L.Draw.Event.CREATED, function (e) {

        });

        const ss = new SimpleMapScreenshoter({preventDownload: true}).addTo(map)
        mapObjects.current.plugins.push(ss)
        const ssInterval = setInterval(() => {
            const ssButton = document.getElementsByClassName('leaflet-control-simpleMapScreenshoter-btn')[0]
            if(ssButton) {
                ssButton.onclick = (e) => {
                    ss.takeScreen('blob', {
                        mimeType: 'image/png'
                    }).then(async blob => {
                        await navigator.clipboard.write([
                            new window.ClipboardItem({ "image/png": blob })
                        ]);

                        notification.success({
                            message: 'Image is copied to clipboard!'
                        })
                    })
                }

                clearInterval(ssInterval)
            }
        }, 100)
    }

    const onChangeLayers = async () => {
        if(!map)
            return

        try {
            await loadReferenceLayers()
            openModal({
                closable: false,
                component: (
                    <div id={'layer-load-info'}>
                        Please wait, Layer is loading...
                    </div>
                ),
                title: 'Layer'
            })
            let time = 0;
            const _interval = setInterval(() => {
                time++;
                if(document.getElementById('layer-load-info'))
                    document.getElementById('layer-load-info').innerText = `Please wait, Layer is loading... (${time} sec)`
            }, 1000)

            loadProjectLayers().then(x => {
                closeModal()
                clearInterval(_interval)
            })

            if(window.bounding) {
                map.removeLayer(window.bounding)
            }

            if(mapContext[type]?.bounding?.showBounding)
            {
                window.bounding = L.polygon(await ShapeFileHelper.getBounding(getRiverBoundingCoords(type), mapContext[type]?.bounding), { color: 'gray' }).addTo(map);

            }
        }
        catch (exp) {
            console.log(exp)
        }
    }

    const onLayerSearch = (item) => {
        if(item.type === 'cross_section') {
            dispatchProject({
                type: AppActions.SET_SELECTED_RS,
                data: {rs: item._text}
            })
        }
    }

    const loadToolbar = () => {
        dispatchProject({
            type: AppActions.SET_MESSAGE_TOOLBAR_ITEM,
            data: {
                toolbar: (
                    <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                        <TileSelect value={tile} onChange={setTile} tiles={getTiles()}/>
                        <ProfileSelect profiles={getMapData(type)?.profiles} onChangeProfile={setProfile} selectedProfile={profile} />
                        <Space.Compact size={'small'}>
                            <LayerSelect type={type}/>
                            <div style={{marginLeft: 8}}>
                                <LayerSearch onChange={onLayerSearch} type={type}/>
                            </div>
                        </Space.Compact>
                    </div>
                )
            }
        })
    }

    const loadReferenceLayers = async () => {
        const _refLayers = mapContext[type].referenceLayers.filter(x => {
            const layer = mapContext[type].selectedLayers.reference.find(y => y.name === x.name)
            if(!layer && x?.layerObject?.remove) {
                x.layerObject.remove()
                return false
            }
            else {
                if(!map.hasLayer(x.layerObject)) {
                    map.addLayer(x.layerObject)
                }
            }

            return true
        })

        for (const x of mapContext[type].selectedLayers.reference) {
            const layer = mapContext[type].referenceLayers.find(y => y.name === x.name)
            if(!layer) {
                // add
                try {
                    openModal({
                        title: 'Layer is loading...',
                        component: (<Spin spinning={true} />),
                        closable: false
                    })

                    // const res = await fetch(`/shapes/${x.file}`);
                    // const layerData = await res.json()
                    //
                    // _refLayers.push({
                    //     ...x,
                    //     layerObject: L.geoJSON(layerData).addTo(map)
                    // })

                    const res = await fetch(`/shapes/${x.file}`);
                    const kmlText = await res.text()

                    const parser = new DOMParser();
                    const kml = parser.parseFromString(kmlText, 'text/xml');
                    const track = new window.L.KML(kml);
                    _refLayers.push({
                        ...x,
                        layerObject: track
                    })
                    map.addLayer(track);
                }
                catch (exp) {
                    console.log(exp)
                }
                closeModal()
            }
        }

        dispatchProject({
            type: AppActions.SET_MAP_CONTEXT,
            data: {
                map: {
                    ...mapContext,
                    [type]: {
                        ...mapContext[type],
                        referenceLayers: [..._refLayers]
                    }
                }
            }
        })
    }

    function applyHillshade(georaster, row, col, zFactor = 1) {
        const width = georaster.width;
        const height = georaster.height;

        // Çevre pikselleri kullanarak z değerlerini al
        const z1 = georaster.values[0][row - 1]?.[col - 1] * zFactor || 0;
        const z2 = georaster.values[0][row - 1]?.[col] * zFactor || 0;
        const z3 = georaster.values[0][row - 1]?.[col + 1] * zFactor || 0;
        const z4 = georaster.values[0][row]?.[col - 1] * zFactor || 0;
        const z5 = georaster.values[0][row]?.[col + 1] * zFactor || 0;
        const z6 = georaster.values[0][row + 1]?.[col - 1] * zFactor || 0;
        const z7 = georaster.values[0][row + 1]?.[col] * zFactor || 0;
        const z8 = georaster.values[0][row + 1]?.[col + 1] * zFactor || 0;

        // dz/dx ve dz/dy eğim hesaplaması
        const dzdx = ((z3 + 2 * z5 + z8) - (z1 + 2 * z4 + z6)) / (8 * georaster.pixelWidth);
        const dzdy = ((z6 + 2 * z7 + z8) - (z1 + 2 * z2 + z3)) / (8 * georaster.pixelHeight);

        // Eğimi ve aspect (açı) hesaplama
        const slope = Math.atan(Math.sqrt(dzdx * dzdx + dzdy * dzdy));
        const aspect = Math.atan2(dzdy, -dzdx);

        // Işık açısı ve aydınlanma hesaplaması
        const azimuth = 315;
        const altitude = 45;
        const radians = (angle) => (angle * Math.PI) / 180;
        const zenith = radians(90 - altitude);
        const azimuthRad = radians(azimuth);

        // Hillshade hesaplama
        const shade = Math.cos(zenith) * Math.cos(slope) +
            Math.sin(zenith) * Math.sin(slope) * Math.cos(azimuthRad - aspect);

        return Math.max(0, Math.min(255, Math.round(255 * shade)));
    }

    function pixelValueToColor(elevationValue, minElevation, maxElevation) {
        const normalizedValue = (elevationValue - minElevation) / (maxElevation - minElevation);

        const colorScale = [
            [102, 205, 170, 255],  // Düşük değer
            [255, 255, 0, 255],    // Sarı
            [0, 128, 0, 255],      // Yeşil
            [255, 165, 0, 255],    // Turuncu
            [139, 0, 0, 255],      // Koyu Kırmızı
            [165, 42, 42, 255],    // Kahverengi
            [128, 128, 128, 255],  // Gri
            [255, 250, 250, 255]   // Beyaz
        ];

        const numColors = colorScale.length;
        const scaleStep = 1 / (numColors - 1);

        let r = 255, g = 255, b = 255;
        for (let i = 0; i < numColors - 1; i++) {
            const lowerBound = i * scaleStep;
            const upperBound = (i + 1) * scaleStep;

            if (normalizedValue >= lowerBound && normalizedValue <= upperBound) {
                const factor = (normalizedValue - lowerBound) / (upperBound - lowerBound);

                r = Math.round(colorScale[i][0] + factor * (colorScale[i + 1][0] - colorScale[i][0]));
                g = Math.round(colorScale[i][1] + factor * (colorScale[i + 1][1] - colorScale[i][1]));
                b = Math.round(colorScale[i][2] + factor * (colorScale[i + 1][2] - colorScale[i][2]));
                break;
            }
        }

        return [r, g, b];
    }

// Gölge efektini renge uygulama fonksiyonu
    function applyShadeToColor(color, shadeValue) {
        // Renk bileşenlerine hillshade uygula (gölge etkisi)
        const factor = shadeValue / 255;
        const r = Math.round(color[0] * factor);
        const g = Math.round(color[1] * factor);
        const b = Math.round(color[2] * factor);

        return [r,g,b];
    }



    const loadProjectLayers = async () => {
        if(!window.projectShapes) {
            window.projectShapes = {}
        }

        Object.keys(window.projectShapes).forEach(key => {
            if(window.projectShapes[key]?.remove){
                window.projectShapes[key].remove()
            }
        })

        // add layers
        for (const x of mapContext[type].selectedLayers.project) {
            const layerRow = getProjectLayers(type).find(y => y.id === x.id)
            if(layerRow) {
                // add
                try {
                    if(layerRow.ext?.toLowerCase() === 'geojson') {
                        const bounding = await ShapeFileHelper.getBounding(getRiverBoundingCoords(type), mapContext[type]?.bounding)
                        let layerData = {}
                        if(typeof layerRow.data === 'string') {
                            layerData = JSON.parse(layerRow.data)
                        }
                        else {
                            layerData = {...layerRow.data}
                        }

                        layerData = ShapeFileHelper.filterFeatures(layerData, layerRow.filters || {}, bounding)

                        const labelGroup = L.markerClusterGroup({
                            zoomToBoundsOnClick: true,
                            maxClusterRadius: (zoom) => {
                                return (zoom >= 25) ? 0 : 40
                            },
                            iconCreateFunction: function(cluster) {
                                return L.divIcon({ html: '<div style="background-color: yellow; width: 24px; border-radius: 16px; border: 2px solid black; font-weight: bold; padding-left: 4px;">' + cluster.getChildCount() + '</div>' });
                            }
                        });

                        labelGroup.addTo(map)
                        window.projectShapes[v4()] = labelGroup;
                        window.projectShapes[layerRow.id] = L.geoJSON(layerData, {
                            pointToLayer: function (feature, latlng) {
                                if(feature?.geometry?.type === 'Point') {
                                    const circleLayer = L.circleMarker(latlng, { // Daire oluşturuluyor
                                        radius: 5, // Dairenin yarıçapı
                                        color: 'black', // Dairenin kenar rengi
                                        fillColor: '#ffff00', // Dairenin dolgu rengi
                                        fillOpacity: 1, // Dolgu opaklığı,
                                    });
                                    // const circleLayer = L.circle(latlng, 0.1, {color: 'black', fillColor: '#ffff00', fillOpacity: 0.5})
                                    circleLayer.bringToFront()
                                    return circleLayer
                                }
                            },
                            onEachFeature: (feature, layer) => {
                                layer.on('mouseover', function (e) {
                                    let key = Object.keys(feature.properties).find(x => x.toLowerCase().includes('id') && feature.properties[x])
                                    if(!key)
                                        key = Object.keys(feature.properties).find(x => feature.properties[x])

                                    let html = ReactDOMServer.renderToString(
                                        <ShapeTooltip
                                            labels={layerRow?.labels || [key]}
                                            feature={feature}
                                        />
                                    );

                                    layer.bindTooltip(L.tooltip({}).setContent(html), {sticky: true}).openTooltip();
                                });

                                layer.on('click', function (e) {
                                    const latlng = e.latlng;
                                    let html = ReactDOMServer.renderToString(
                                        <ShapeItem
                                            feature={feature}
                                        />
                                    );

                                    const content = `<div style="max-height: 380px; overflow-y: auto">${html}</div>`
                                    L.popup({autoPan: true})
                                        .setLatLng(latlng)
                                        .setContent(content)
                                        .openOn(map);
                                });
                            }
                        }).addTo(labelGroup)
                        labelGroup.bringToFront()
                    }
                    else if(layerRow.ext?.toLowerCase() === 'tif') {
                        console.log(layerRow)

                        const georaster = JSON.parse(JSON.stringify(layerRow.data))
                        const hillshade = applyHillshade(georaster)

                        let rows = 1
                        let columns = 1

                        const tifLayerColor = new GeoRasterLayer({
                            georaster: georaster,
                            opacity: mapContext[type]?.terrainLayers?.opacity_size,
                            pixelValuesToColorFn: (pixelValues) => {
                                if(columns === georaster.width) {
                                    rows++;
                                    columns = 1
                                }
                                else {
                                    columns++
                                }

                                const pixelValue = pixelValues[0];
                                if (pixelValue === 0)
                                    return null;

                                const hillshadeValue = applyHillshade(georaster, rows-1, columns-1);
                                const color = pixelValueToColor(pixelValue, georaster?.mins[0], georaster?.maxs[0]);
                                const [r,g,b]  = applyShadeToColor(color, hillshadeValue);
                                const hex = (1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1).toUpperCase();
                                return `#${hex}`;
                            },
                            resolution:  mapContext[type]?.terrainLayers?.resolution_size // optional parameter for adjusting display resolution
                        });




                        const hillshades = []
                        for(let r=0; r < georaster.height; r++) {
                            for(let c = 0 ; c < georaster.width; c++) {
                                hillshades.push(applyHillshade(georaster, r, c, mapContext[type]?.terrainLayers?.gray_z_factor));
                            }
                        }


                        const canvas = document.createElement('canvas');
                        canvas.width = georaster.width;
                        canvas.height = georaster.height;
                        const ctx = canvas.getContext('2d');
                        const imageData = ctx.createImageData(georaster.width, georaster.height);

                        for (let i = 0; i < hillshades.length; i++) {
                            imageData.data[4 * i] = hillshades[i];
                            imageData.data[4 * i + 1] = hillshades[i];
                            imageData.data[4 * i + 2] = hillshades[i];
                            imageData.data[4 * i + 3] = 255 * (mapContext[type]?.terrainLayers?.gray_opacity_size);  // Opaklık (alpha)
                        }

                        ctx.putImageData(imageData, 0, 0);
                        const hillshadeUrl = canvas.toDataURL();

                        const tifLayerGray = L.imageOverlay(hillshadeUrl, tifLayerColor.getBounds(), {});

                        map.fitBounds(tifLayerGray.getBounds());
                        map.fitBounds(tifLayerColor.getBounds());


                        tifLayerGray.addTo(map);
                        tifLayerColor.addTo(map);

                        window.projectShapes[v4()] = tifLayerColor;
                        window.projectShapes[v4()] = tifLayerGray;
                    }
                }
                catch (exp) {
                    console.log(exp)
                }
            }
        }
    }

    const loadRiverStream = (zoomChanged) => {
        // zoom degistiginde butun riveri tekrar render etme
        if(mapObjects.current.river && !zoomChanged)
        {
            mapObjects.current.river.remove()
            mapObjects.current.river = null
        }

        if(mapContext[type].selectedLayers.model.includes('Flow Direction'))
        {
            // const freq = `${(mapContext[type]?.flowArrow?.freq / 3.28)}m` || '50m'
            const zoom = mapContext[type]?.zoom || 18
            const zoomSize = 25 - zoom
            const verticalDistance = getVerticalDistance()
            let freq_dist = verticalDistance / mapContext[type]?.flowArrow?.flow_count
            let freq = `${freq_dist < 100 ? 100 : freq_dist}m` || '500m'
            let size = `${mapContext[type]?.flowArrow?.flow_size + zoomSize}px` || '15px'

            if(zoomChanged && mapObjects.current.river) {
                mapObjects.current.river.arrowheads({frequency: freq, fill: false, size: size, color: '#04d9ff'}).addTo(map);
            }
            else {
                mapObjects.current.river = L.polyline(getMapData(type).reach_xy, { color: 'blue' }).arrowheads({frequency: freq, fill: false, size: size, color: '#04d9ff'}).addTo(map);
            }
        }
        else {
            if(!zoomChanged) {
                mapObjects.current.river = L.polyline(getMapData(type).reach_xy, { color: 'blue' }).addTo(map);
            }
        }
    }

    const setRS2MapCenter = async (zoom) => {
        let mapRS = getMapData(type)?.cross_sections?.find(x => x?.cross_section && parseFloat(x?.cross_section?.toString()) === parseFloat(getSelectedRS()?.cross_section?.toString()))
        let xy = mapRS?.center

        if(!mapRS)
        {
            mapRS = getMapData(type)?.structures?.find(x => x?.cross_section && parseFloat(x?.cross_section?.toString()) === parseFloat(getSelectedRS()?.cross_section?.toString()))

            xy = mapRS?.xy_list[0];
            if(mapRS?.xy_list[0]?.xy) {
                xy = mapRS?.xy_list[0]?.xy
            }
        }

        if(!xy) {
            await fullExtend()
            return
        }

        const center = getCenter(xy)
        map.setView(center, zoom)
    }

    const loadStructures = () => {
        if(mapObjects.current.structureLayer?.remove)
        {
            mapObjects.current.structureLayer.remove()
            mapObjects.current.structures = []
        }


        mapObjects.current.structureLayer = L.layerGroup()

        getMapData(type)?.structures?.forEach(cs => {
            cs?.xy_list?.forEach(item => {
                const xy = item.xy || []

                const polygon = L.polygon(xy || [], {
                    color: cs.cross_section === getSelectedRS()?.cross_section ? 'red' : getColor(cs.cross_section, 'structure', tile.structure),
                    fillColor: 'gray',
                    weight: 5
                }).addTo(mapObjects.current.structureLayer)
                polygon.cross_section = cs.cross_section
                polygon.search = cs.cross_section
                mapObjects.current.structures.push(polygon)
            })
        })

        mapObjects?.current?.structureLayer?.addTo(map)
        mapObjects?.current?.structures?.forEach(x => x.bringToBack())
    }

    const loadMultipleOpeningLines = () => {
        if(mapObjects.current.multipleOpeningLinesLayer?.remove)
        {
            mapObjects.current.multipleOpeningLinesLayer.remove()
            mapObjects.current.multipleOpeningLines = []
        }

        if(!mapContext[type].selectedLayers.model.includes('Multiple Opening'))
            return;

        mapObjects.current.multipleOpeningLinesLayer = L.layerGroup()

        getMapData(type)?.multiple_openings?.forEach(opening => {
            opening?.opening_xy_list?.forEach(xy => {
                mapObjects.current.multipleOpeningLines.push(L.polyline(xy || [], { color: 'red', weight: 1, dashArray: '3, 3', dashOffset: '5' }).addTo(mapObjects.current.multipleOpeningLinesLayer))
            })
        })

        mapObjects.current.multipleOpeningLinesLayer.addTo(map)
    }

    const loadFlowPaths = (profile) => {
        if(mapObjects.current.flow_path_left?.remove)
        {
            mapObjects.current.flow_path_left.remove()
            mapObjects.current.flow_path_left = null
        }

        if(mapObjects.current.flow_path_right?.remove)
        {
            mapObjects.current.flow_path_right.remove()
            mapObjects.current.flow_path_right = null
        }

        if(!mapContext[type].selectedLayers.model.includes('Flow Path'))
            return;

        const item = getMapData(type)?.flow_paths?.find(x => x.profile === profile?.target)
        if(!item)
            return;


        mapObjects.current.flow_path_left = L.polyline(item?.left_coords || [], { color: 'red' }).addTo(map);
        mapObjects.current.flow_path_right = L.polyline(item?.right_coords || [], { color: 'red' }).addTo(map);
    }

    const loadFloodExtends = (profile) => {
        if(mapObjects.current.floodExtendsLayer?.remove)
        {
            mapObjects.current.floodExtendsLayer.remove()
            mapObjects.current.floodExtends = []
        }

        if(!mapContext[type].selectedLayers.model.includes('Flood Extent'))
            return;

        mapObjects.current.floodExtendsLayer = L.layerGroup()

        const floodExtends = _.groupBy(getMapData(type)?.flood_extends, (x) => x.profile)
        Object.keys(floodExtends)?.forEach(key => {
            if(profile?.target === key) {
                floodExtends[key].forEach(item => {
                    mapObjects.current.floodExtends.push(L.polyline(item?.xy || [], { color: 'blue', weight: 3, }).addTo(mapObjects.current.floodExtendsLayer))
                })
            }
        })

        mapObjects.current.floodExtendsLayer.addTo(map)
    }

    const loadBlockObstr = () => {
        if(mapObjects.current.blockObstLayer?.remove)
        {
            mapObjects.current.blockObstLayer.remove()
            mapObjects.current.blockObst = []
        }

        if(!mapContext[type].selectedLayers.model.includes('Blocked Obstruction'))
            return;

        mapObjects.current.blockObstLayer = L.layerGroup()

        getMapData(type)?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                if(cs?.block_obstr?.length > 0) {
                    for (const blockObstr of cs.block_obstr) {
                        mapObjects.current.blockObst.push(L.polyline(blockObstr, { color: 'black', weight: 2, }).addTo(mapObjects.current.blockObstLayer))
                    }
                }
            }
        })

        mapObjects.current.blockObstLayer.addTo(map)
    }

    const moveLine = (p1, p2, L, dist) => {
        // Verilen iki nokta
        const point1 = { x: p1[0], y: p1[1] };
        const point2 = { x: p2[0], y: p2[1] };
        const deltaX = point2.x - point1.x;
        const deltaY = point2.y - point1.y;
        const length = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const normalX = dist * (deltaY / length);
        const normalY = dist * (-deltaX / length);

        const secondPoint1 = { x: point1.x + normalX, y: point1.y + normalY };
        const secondPoint2 = { x: point2.x + normalX, y: point2.y + normalY };

        const div = secondPoint2.x - secondPoint1.x
        const m = (secondPoint2.y - secondPoint1.y) / (div !== 0 ? div : 0.0001); // Eğim
        const b = secondPoint1.y - m * secondPoint1.x; // Sabit terim

        const centerX = (secondPoint1.x + secondPoint2.x) / 2;
        const centerY = (secondPoint1.y + secondPoint2.y) / 2;

        const startNewX = centerX + L;
        const startNewY = m * startNewX + b;

        const endNewX = centerX - L;
        const endNewY = m * endNewX + b;

        return {p1: [startNewX, startNewY], p2: [endNewX, endNewY]}
    }

    const getSquare = (p1, p2) => {
        const start = { x: p1[0], y: p1[1] };
        const end = { x: p2[0], y: p2[1] };

        const distance = Math.sqrt(Math.pow(end.x - start.x, 2) + Math.pow(end.y - start.y, 2));

        const op1 = {
            x: end.x + (start.y - end.y) / distance * distance,
            y: end.y + (end.x - start.x) / distance * distance
        };

        const op2 = {
            x: start.x + (start.y - end.y) / distance * distance,
            y: start.y + (end.x - start.x) / distance * distance
        };

        return [p1, p2, [op1.x, op1.y], [op2.x, op2.y]]
    }

    const getSquareFromCenter = (center, R) => {
        const centerLat = center[0]
        const centerLng = center[1]
        const correction_factor = Math.cos(centerLat * Math.PI / 180);

        const topLat = centerLat + (R / 111139);
        const bottomLat = centerLat - (R / 111139);
        const leftLng = centerLng - (R / (111139 * correction_factor));
        const rightLng = centerLng + (R / (111139 * correction_factor));

        const square = {
            top_left: { lat: topLat, lng: leftLng },
            top_right: { lat: topLat, lng: rightLng },
            bottom_left: { lat: bottomLat, lng: leftLng },
            bottom_right: { lat: bottomLat, lng: rightLng }
        };

        return [square.top_left, square.top_right, square.bottom_right, square.bottom_left]
    }

    const loadBoundaryTable = () => {
        if(mapObjects.current.downstreamBoundary?.remove)
        {
            mapObjects.current.downstreamBoundary.remove()
        }

        if(!mapContext[type].selectedLayers.model.includes('Boundary Condition'))
            return;

        const boundary = getMapData(type)?.boundary
        if(boundary) {
            if(boundary?.chords?.length < 1)
                return;

            let R = (getVerticalDistance()/40)
            R = R*mapContext[type]?.flowArrow?.boundary_size/100

            const square_coords = getSquareFromCenter(boundary?.chords[0], R)
            const square = L.polygon(square_coords, {
                color: '#04d9ff',     // Çokgenin kenar rengi
                fillColor: '#f00', // Çokgenin iç dolgu rengi
                fillOpacity: 0.0,   // Çokgenin iç dolgu opaklığı
                weight: 5
            })

            mapObjects.current.downstreamBoundary = square.on('click', (e) => {
                const latlng = e.latlng;
                createLeafletPopup({
                    L,
                    content: (<BoundaryTable data={boundary?.data} />),
                    contentStyle: {
                        maxHeight: 600,
                        overflowY: 'auto'
                    },
                    properties: {autoPan: true, minWidth: HecRasHelper.getWidth(40)},
                    latlng,
                    map
                })
            })

            mapObjects.current.downstreamBoundary.addTo(map)
        }
    }

    const getVerticalDistance = () => {
        const northBound = map.getBounds().getNorth();
        const southBound = map.getBounds().getSouth();
        return L.latLng(northBound, 0).distanceTo(L.latLng(southBound, 0));
    }

    const loadFlowChangeTable = () => {
        if(mapObjects.current.flowChangeLayer?.remove)
        {
            mapObjects.current.flowChangeLayer.remove()
            mapObjects.current.flowChanges = []
        }

        if(!mapContext[type].selectedLayers.model.includes('Flow Change Location'))
            return;

        // Haritanın kuzey ve güney sınırlarını alın
        const vDist = getVerticalDistance()

        mapObjects.current.flowChangeLayer = L.layerGroup()
        getMapData(type)?.flow_change_locations?.forEach(fl => {
            if(fl?.chords?.length < 1)
                return;

            const circle = L.circle(fl?.chords[0], {
                color: '#04d9ff',      // Çemberin kenar rengi
                fillColor: '#f03', // Çemberin iç dolgu rengi
                fillOpacity: 0.0,  // Çemberin iç dolgu opaklığı
                radius: ((vDist/20)/4)*mapContext[type]?.flowArrow?.flow_change_size/50,
                weight: 5
            })

            circle.on('click', (e) => {
                const latlng = e.latlng;
                createLeafletPopup({
                    L,
                    content: (<FlowChangeTable data={getMapData(type)?.flow_change_locations || []} profiles={getMapData(type)?.profiles?.map(x => x.targetName)} selectedCS={fl?.cross_section} />),
                    contentStyle: {
                        maxHeight: 600,
                        overflowY: 'auto'
                    },
                    properties: {autoPan: true, minWidth: HecRasHelper.getWidth(17+getMapData(type)?.profiles?.length*10)},
                    latlng,
                    map
                })
            })

            circle.addTo(mapObjects.current.flowChangeLayer)
        })
        mapObjects.current.flowChangeLayer.addTo(map)
    }

    const loadTexts = () => {
        if(mapObjects.current.textLayer?.remove)
        {
            mapObjects.current.textLayer.remove()
            mapObjects.current.crossSectionTexts = []
            mapObjects.current.structureTexts = []
        }

        // mapObjects.current.textLayer = L.inflatableMarkersGroup({
        //     iconCreateFunction: function (icon) {return L.divIcon({html: `<div style="color: ${tile.textColor}"></div>`, iconSize: [0,0]});}
        // }).addTo(map);

        mapObjects.current.textLayer = L.markerClusterGroup({
            zoomToBoundsOnClick: true,
            iconCreateFunction: function(cluster) {
                return L.divIcon({ html: cluster.getAllChildMarkers()[0]?.options?.icon?.options?.html, className: 'dummy',});
            }
        }).addTo(map);

        getMapData(type)?.cross_sections?.forEach(cs => {
            let cs_text = `<div style="color: ${getColor(cs?.cross_section, 'text', tile.textColor)}">${cs?.cross_section}</div>`
            if(cs?.ratio && parseFloat(cs?.ratio?.toFixed(2)) !== 1) {
                let color = 'red'
                let skew_r = (1/Math.cos(parseFloat(cs?.skew) * Math.PI / 180)).toPrecision(3)
                if(skew_r === parseFloat(cs?.ratio).toPrecision(3)) {
                    color = 'green'
                }

                cs_text = `<div style="color: ${getColor(cs?.cross_section, 'text', tile.textColor)}">${cs?.cross_section}<br/><div style="color: ${color};">r=${cs.ratio?.toFixed(2)}</div></div>`
            }

            const text = L.divIcon({
                className: 'dummy',
                html: cs_text,
                iconSize: [100, 30], // Metnin boyutu
            })

            const marker = L.marker(cs.xy[0], {icon: text}).addTo(mapObjects.current.textLayer);
            marker.cross_section = cs.cross_section
            marker.on('click', (e) => {
                const latlng = e.latlng;
                createLeafletPopup({
                    L,
                    content: (<CrossSectionWindow riverStation={{base_ui_data: cs?.cs_ui, base_title: cs?.cross_section}} />),
                    contentStyle: {
                        maxHeight: 800,
                        overflowY: 'auto'
                    },
                    properties: {autoPan: true, maxWidth: 760},
                    latlng,
                    map
                })
            })
            mapObjects.current.crossSectionTexts.push(marker)
        })

        getMapData(type)?.structures?.forEach(cs => {
            cs?.xy_list?.forEach(item => {
                const xy = item.xy || []

                const str_center_x = (xy?.map(x => x[0]).reduce((a, b) => a + b))/xy?.length
                const str_center_y = (xy?.map(x => x[1]).reduce((a, b) => a + b))/xy?.length

                const text_marker = L.marker([str_center_x, str_center_y], {
                    icon: L.divIcon({
                        className: 'dummy',
                        html: ReactDOMServer.renderToString(<StructureName textColor={getColor(cs?.cross_section, 'text', tile.textColor)} selectedRS={getSelectedRS()?.cross_section} cs={cs} strItem={item} />), // Buraya istediğiniz metni ekleyin
                        iconSize: [100, 30], // Metnin boyutu
                    }),
                    search: cs.cross_section
                }).addTo(mapObjects.current.textLayer)
                text_marker.cs_data = cs
                text_marker.on('click', (e) => {
                    const latlng = e.latlng;
                    let content = ``
                    if(cs.typeName === 'Culvert') {
                        content = <CulvertTable r={cs?.str_table} />;
                    }
                    else if(cs.typeName === 'Bridge') {
                        content = <BridgeTable r={cs?.str_table} />;
                    }

                    createLeafletPopup({
                        L,
                        content,
                        contentStyle: {
                            overflowY: 'auto',
                            width: HecRasHelper.getWidth(50)
                        },
                        properties: {autoPan: true, maxWidth: HecRasHelper.getWidth(75)},
                        latlng,
                        map
                    })
                })

                mapObjects.current.structureTexts.push(text_marker)
            })
        })
    }

    const loadCrossSections = () => {
        if(mapObjects.current.crossSectionLayer?.remove)
        {
            mapObjects.current.crossSectionLayer.remove()
            mapObjects.current.crossSections = []
        }

        mapObjects.current.crossSectionLayer = L.layerGroup()


        getMapData(type)?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                const polyline = L.polyline(cs?.xy, { color: getSelectedRS()?.cross_section === cs.cross_section ? 'red' : getColor(cs.cross_section, 'cross_section', tile.csColor), weight: 1, }).addTo(mapObjects.current.crossSectionLayer)
                polyline.cross_section = cs.cross_section
                polyline.search = cs.cross_section
                polyline.on('click', () => {

                })
                mapObjects.current.crossSections.push(polyline)
            }
        })

        mapObjects.current.crossSectionLayer.addTo(map)
    }

    const loadIneffs = () => {
        if(mapObjects.current.ineffLayer?.remove)
        {
            mapObjects.current.ineffLayer.remove();
            mapObjects.current.ineffs = []
        }

        if(!mapContext[type].selectedLayers.model.includes('Ineffective Area'))
            return;

        if(map.getZoom() < 17)
            return

        mapObjects.current.ineffLayer = L.layerGroup();
        getMapData(type)?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                cs?.ineffs?.forEach(ineff => {
                    const ineff_icon = L.icon({
                        iconUrl: '/icons/ineff_icon.png', // İkon resmi dosya yolu
                        iconSize: [12, 12], // İkon boyutu
                    });
                    mapObjects.current.ineffs.push(L.marker(ineff?.xy, { icon: ineff_icon }).addTo(mapObjects.current.ineffLayer))
                })
            }
        })

        mapObjects.current.ineffLayer.addTo(map)
    }

    const isLoadMannings = () => {
        if(!mapContext[type].selectedLayers.model.includes('Mannings N'))
            return false;

        if(mapContext[type]?.zoom < 17)
            return false

        return true
    }

    const loadMannings = () => {
        if(mapObjects.current.manningsLayer?.remove)
        {
            mapObjects.current.manningsLayer.remove();
            mapObjects.current.mannings = []
        }

        if(mapObjects.current.manningsTextLayer?.remove)
        {
            mapObjects.current.manningsTextLayer.remove();
            mapObjects.current.manningsTextLayer = []
        }

        if(!isLoadMannings())
            return

        mapObjects.current.manningsLayer = L.layerGroup().addTo(map);
        mapObjects.current.manningsTextLayer = L.inflatableMarkersGroup({
            iconCreateFunction: function (icon) {return L.divIcon({html: `<div style="color: ${tile.textColor}"></div>`, iconSize: [0,0]});}
        }).addTo(map);

        getMapData(type)?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                cs.manns?.forEach(mann => {
                    if(!mann)
                        return

                    mapObjects.current.mannings.push(L.polyline(mann, { color: tile.textColor, weight: 1, }).addTo(mapObjects.current.manningsLayer))
                })

                cs?.manns_text?.forEach(mann_text => {
                    mapObjects.current.manningsTexts.push(
                        L.marker(mann_text?.chord?.xy, {
                            icon: L.divIcon({
                                className: 'dummy',
                                html: `<div style="color:${tile.textColor}; ">n: ${mann_text?.text}</div>`, // Buraya istediğiniz metni ekleyin
                                iconSize: [48, 20], // Metnin boyutu
                                iconAnchor: [0, -15]
                            })
                        }).addTo(mapObjects.current.manningsTextLayer)
                    )
                })
            }
        })
    }

    const loadBankStations = () => {
        if(mapObjects.current.banksLayer?.remove)
        {
            mapObjects.current.banksLayer.remove();
            mapObjects.current.banks = []
        }

        if(!mapContext[type].selectedLayers.model.includes('Bank Station'))
            return;

        mapObjects.current.banksLayer = L.layerGroup();
        getMapData(type)?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                cs?.banks?.forEach(b => {
                    const bank = L.circle(b?.xy, 0.5, {color: 'red', fillColor: 'red', fillOpacity: 0.5}).addTo(mapObjects.current.banksLayer)

                    const mouseOver = (e) => {
                        const latlng = e.latlng;
                        createLeafletPopup({
                            L,
                            content: (
                                <ResultTable>
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'left'}}>RS</ResultHeaderCell>
                                        <ResultBodyCell style={{textAlign: 'left',}}>{cs?.cross_section}</ResultBodyCell>
                                    </ResultRow>
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'left'}}>Station</ResultHeaderCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{b?.station}</ResultBodyCell>
                                    </ResultRow>
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'left'}}>Elevation</ResultHeaderCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{b?.elev}</ResultBodyCell>
                                    </ResultRow>
                                </ResultTable>
                            ),
                            contentStyle: {
                                maxHeight: 100,
                                overflowY: 'auto'
                            },
                            properties: {autoPan: true, maxWidth: 200},
                            latlng,
                            map
                        })
                    }
                    bank.on('click', mouseOver)
                    bank.on('mouseover', mouseOver)

                    mapObjects.current.banks.push(bank)
                })
            }
        })
        mapObjects.current.banksLayer.addTo(map)
    }

    const loadLayers = (zoomChanged) => {
        if(!map)
            return

        if(mapObjects.current.loadLayerTimeout) {
            clearTimeout(mapObjects.current.loadLayerTimeout)
        }

        mapObjects.current.loadLayerTimeout = setTimeout(() => {
            loadRiverStream(zoomChanged)
            loadStructures()
            loadCrossSections()
            loadMultipleOpeningLines()
            loadFloodExtends(profile || getMapData(type).profiles[0])
            loadFlowPaths(profile || getMapData(type).profiles[0])
            loadBlockObstr()
            loadBoundaryTable()
            loadFlowChangeTable()
            loadTexts()
            loadIneffs()
            loadMannings()
            loadBankStations()
        }, 200)
    }

    const clearLayers = () => {
        if(map) {
            map.eachLayer(function (layer) {
                map.removeLayer(layer);
            });
        }
        if(mapObjects.current.tile?.remove)
            mapObjects.current.tile.remove()
        if(mapObjects.current.river?.remove)
            mapObjects.current.river.remove()
        if(mapObjects.current.streamArrow?.remove)
            mapObjects.current.streamArrow.remove()
        if(mapObjects.current.banksLayer?.remove)
            mapObjects.current.banksLayer.remove()
        if(mapObjects.current.manningsLayer?.remove)
            mapObjects.current.manningsLayer.remove()
        if(mapObjects.current.manningsTextLayer?.remove)
            mapObjects.current.manningsTextLayer.remove()
        if(mapObjects.current.ineffLayer?.remove)
            mapObjects.current.ineffLayer.remove()
        if(mapObjects.current.crossSectionLayer?.remove)
            mapObjects.current.crossSectionLayer.remove()
        if(mapObjects.current.crossSectionTextLayer?.remove)
            mapObjects.current.crossSectionTextLayer.remove()
        if(mapObjects.current.flowChangeLayer?.remove)
            mapObjects.current.flowChangeLayer.remove()
        if(mapObjects.current.downstreamBoundary?.remove)
            mapObjects.current.downstreamBoundary.remove()
        if(mapObjects.current.blockObstLayer?.remove)
            mapObjects.current.blockObstLayer.remove()
        if(mapObjects.current.structureLayer?.remove)
            mapObjects.current.structureLayer.remove()
        if(mapObjects.current.structureTextLayer?.remove)
            mapObjects.current.structureTextLayer.remove()
        if(mapObjects.current.multipleOpeningLinesLayer?.remove)
            mapObjects.current.multipleOpeningLinesLayer.remove()
        if(mapObjects.current.floodExtendsLayer?.remove)
            mapObjects.current.floodExtendsLayer.remove()
        if(mapObjects.current.searchLayer?.remove)
            mapObjects.current.searchLayer.remove()
        if(mapObjects.current.textLayer?.remove)
            mapObjects.current.textLayer.remove()
    }

    const onContextMenuMap = async (e) => {
        const elements = document.getElementsByClassName('leaflet-control-coord-projection')
        if(elements?.length > 0) {
            const coordDiv = elements[0]
            const text = coordDiv.innerText.split('|').map(x => x?.trim())?.join('\t')
            await navigator.clipboard.writeText(`${text}\n${e?.latlng?.lat}\t${e?.latlng?.lng}`)
            // Modal.info({
            //     title: ``,
            //     content: (
            //         <>
            //
            //         </>
            //     ),
            //     footer: null
            // })
        }
    }

    const onZoomEnd = (e) => {
        dispatchProject({
            type: AppActions.SET_MAP_ZOOM,
            data: {zoom: map.getZoom(), type}
        })
    }

    useEffect(() => {
        loadLayers(false)
        onChangeLayers()
    }, [mapContext[type].update]);

    useEffect(() => {
        if(getSelectedHistory()?.page?.filter?.us || getSelectedHistory()?.page?.filter?.ds) {
            if(!map)
                return

            loadStructures()
            loadCrossSections()
            loadTexts()
        }
    }, [getSelectedHistory()?.page?.filter?.us, getSelectedHistory()?.page?.filter?.ds]);

    useEffect(() => {
        const selection = getSelectedHistory()?.selection[type]
        const event = new CustomEvent('change-project-info', {
            detail: {
                [type]: {
                    title: `${selection?.project?.information?.title} (${selection?.project?.information?.folderName})`,
                    plan: `${selection?.plan?.type} (.${selection?.plan?.plan?.ext})`,
                    river: selection?.river?.river ? `${selection?.river?.river} - ${selection?.river?.reach}` : '',
                    color: tile.textColor
                }
            }
        });
        window.dispatchEvent(event)
    }, [mapContext[type].update, tile, selectedHistoryId]);

    const runFullExtend = (e) => {
        if(e?.detail?.type === type) {
            setFullExtendEvent(v4())
        }
    }

    useEffect(() => {
        if(map && !isReady.current) {
            isReady.current = true

            loadToolbar()
            loadPlugins()

            // map.on('moveend', async (e) => {})
            map.on('zoomend', onZoomEnd)
            map.on('contextmenu', onContextMenuMap)

            window.addEventListener('resize', handleResize);
            window.addEventListener('full-extend', runFullExtend);

            return () => {
                window.removeEventListener('resize', handleResize);
                window.removeEventListener('full-extend', runFullExtend);

                dispatchProject({
                    type: AppActions.SET_MESSAGE_TOOLBAR_ITEM,
                    data: {toolbar: null}
                })

                clearLayers()
            };
        }

        return () => {
            if(map) {
                map.off('contextmenu', onContextMenuMap)
                map.off('zoomend', onZoomEnd)
            }
        }
    }, [map]);

    useEffect(() => {
        if(fullExtendEvent) {
            fullExtend()
        }
    }, [fullExtendEvent]);

    useEffect(() => {
        if(getMapData(type) && map && profile?.target) {
            loadFloodExtends(profile)
            loadFlowPaths(profile)
        }
    }, [profile?.target]);

    useEffect(() => {

        if(getMapData(type) && map) {
            if(mapObjects.current.tile) {
                map.removeLayer(mapObjects.current.tile)
            }

            mapObjects.current.tile = window.L.tileLayer(tile.url, tile.options || {maxZoom: 35})
            mapObjects.current.tile.addTo(map)

            loadLayers(false)
        }
    }, [tile, map]);

    useEffect(() => {
        if(mapContext[type]?.zoom && map && getMapData(type)) {
            loadLayers(true)
        }

    }, [mapContext[type]?.zoom]);

    useEffect(() => {
        if(map && getMapData(type)) {
            if(getSelectedRS()?.cross_section)
            {
                loadLayers(false)
                setRS2MapCenter(!prevSelectedRS.current ? 18 : map.getZoom())
                prevSelectedRS.current = getSelectedRS()?.cross_section
            }
            else {
                fullExtend()
            }
        }
    }, [getSelectedRS()?.cross_section, map]);

    useEffect(() => {
        if(map && getMapData(type)) {
            loadLayers(false)
        }
    }, [selectedHistoryId]);

    useEffect(() => {
        const mapContainer = document.getElementById('map-container-tab')
        if(mapContainer && map) {
            mapContainer.style.width = `${size.width}px`;
            mapContainer.style.height = `${size.height}px`;
            map.invalidateSize();
        }
    }, [size]);

    return (
        <div key={`map-tab`}>
            <MapContainer
                id={'map-container-tab'}
                center={[51.505, -0.09]}
                zoom={mapContext[type]?.zoom}
                zoomSnap={0.1}
                popupMovable={true}
                style={{ height: size.height, width: size.width }}
                whenReady={(_map) => {
                    setMap(_map.target)
                }}
            >

            </MapContainer>
        </div>
    )
}